<script setup>
import { ref, onMounted } from "vue";

import TaxonomyList from "./TaxonomyList.vue";
import FeedService from "../services/FeedService.js";
import { useFilteredFeedStore } from "../stores/FilteredFeed.js";

const store = useFilteredFeedStore();
const { endpoint } = store;

const items = ref(null);

/**
 * Filter bar only for events due to the additional requirements in the designs
 */

onMounted(() => {
	FeedService.getTaxonomies({ params: { post_type: endpoint, mode: store.mode } })
		.then((response) => {
			items.value = response.data.taxonomies;
		})
		.catch((error) => {
			console.log(error);
		});
});

function doFilter() {
	if (store.filters) {
		store.fetchItems();
	}
}

let days = null;

if (store.mode === 'past') {
	days = ref([
		{
			title: "Thursday",
			filter: "2024-06-06"
		},
		{
			title: "Friday",
			filter: "2024-06-07"
		},
		{
			title: "Saturday",
			filter: "2024-06-08"
		},
		{
			title: "Sunday",
			filter: "2024-06-09"
		},
	]);
}

function filterByDay(day, filter) {
	if (filter) {
		store.filterDay = day;
		store.updateFilters({
			taxonomy: "start_date",
			term: filter,
		}, true);
		store.updateFilters({
			taxonomy: "end_date",
			term: filter,
		}, true);
		store.setState();
	} else {
		delete store.filters.start_date;
		delete store.filters.end_date;
		store.filterDay = null;
		store.setState();
	}
}
</script>

<template>
	<section @keyup.right="">
		<section class="gs-x gs-y bg-purple text-white">
			<div class="xl:container mx-auto">
				<div class="flex flex-col items-center gap-8">
					<span class="font-serif text-xl" v-text="store.filterTitle"></span>
					<hr class="border-white border-b-4 w-full" />

					<div class="flex items-center gap-4 sm:gap-16 flex-col-reverse sm:flex-row ">
						<ul
							class="w-full flex flex-col md:flex-row md:flex-wrap md:justify-center items-start gap-4 md:gap-8 desktop:gap-x-16"
							role="menubar"
							aria-label="Filter navigation"
						>
							<TaxonomyList
								:title="item.name"
								:taxonomy="item.slug"
								:items="item.terms"
								v-for="item in items"
								:id="item.id"
								:key="item.id"
								:inline="store.hasSingleTaxonomy"
							/>

							<li role="menuitem" v-if="days">
								<a @click.prevent="filterByDay(null, null)" href="#" aria-label="Show events on all days" class="text-xl font-medium">
									<span>All days</span>
								</a>
							</li>
							<li role="menuitem" v-for="day in days">
								<a
									@click.prevent="filterByDay(day.title, day.filter)"
									href="#"
									:aria-label="day.title == store.filterDay ? 'Show all days' : 'Show events on ' + day.title.toLowerCase()"
									class="text-xl font-medium"
									:class="{ 'underline decoration-1': day.title == store.filterDay }"
								>
									<span v-html="day.title"></span>
								</a>
							</li>
						</ul>
						<div>
							<a href="#" class="button button-small" v-show="store.isFiltered" aria-label="clear filters" role="menuitem" @click.prevent="store.clearFilters()"
								>Clear filters</a
							>
						</div>
					</div>
					<div aria-live="assertive" aria-atomic="true" class="sr-only" v-if="store.items && store.isFiltered" v-html="store.filterMessage"></div>
				</div>
			</div>
		</section>
	</section>
</template>

<style></style>
